<template>
  <div class="row goal-summary">
    <div class="col-md-4">
      <div class="card card-office-goal">
        <div class="card-body">
          <img :src="iconGoal" alt="My Goal">
          <h3 class="font-weight-bold">{{ goal }}</h3>
          <p class="mb-0">My Goal</p>
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <div class="card card-office-actual">
        <div class="card-body">
          <img :src="iconActual" alt="My Actual">
          <h3 class="font-weight-bold">{{ actual }}</h3>
          <p class="mb-0">My Actual</p>
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <div class="card card-office-pending">
        <div class="card-body">
          <img :src="iconPending" alt="My Pending">
          <h3 class="font-weight-bold">{{ getTotalPending() }}</h3>
          <p class="mb-0">Pending</p>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="card card-my-contribution">
        <div class="card-body">
          <img :src="iconPercentage" alt="My Contribution">
          <h3 class="font-weight-bold">{{ contribution.toFixed(2) }}%</h3>
          <p class="mb-0">Guide Contribution in %</p>
          <small v-if="contribution === 0" class="text-danger">Office goal not set</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OfficeGoalsSummary',
  props: {
    goal: {
      type: Number,
      default: 0
    },
    actual: {
      type: Number,
      default: 0
    },
    pending: {
      type: Number,
      default: 0
    },
    contribution: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      iconGoal: '/images/icons-goals/ranking.svg',
      iconActual: '/images/icons-goals/medal-star.svg',
      iconPending: '/images/icons-goals/note-2.svg',
      iconPercentage: '/images/icons-goals/percentage-square.svg',
    }
  },
  methods: {
    getTotalPending() {
      if (this.actual > this.goal) {
        return 0;
      }

      return this.pending;
    }
  }
}
</script>